import { Box } from '@mui/material';
import styled from '@emotion/styled';

import { EuroHouseIcon } from '@widget/toolbox/components/Icon/icons/EuroHouseIcon';
import { Typography } from '@widget/toolbox/components';

import type React from 'react';

type ValuationBackgroundProps = {
  showIcon?: boolean;
  propertyType: string;
  address: string;
};

const StyledBox = styled(Box)`
  display: flex;
  align-items: center;
  flex-direction: column;
`;

const StyledText = styled(Typography)`
  margin: 24px 0;
  font-weight: 500;
  font-size: ${({ theme }) => theme.fontSizes.f5};
  text-align: center;
  max-width: 340px;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    font-size: ${({ theme }) => theme.fontSizes.f3};
  }
`;

const StyledTextWrapper = styled.div`
  font-weight: bold;
`;

const BlurredText = styled.span`
  filter: blur(5px);
`;

const IconHouse = styled(EuroHouseIcon)`
  margin-bottom: ${({ theme }) => theme.spacing(6)};

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    width: 80px;
    height: auto;
    margin-bottom: ${({ theme }) => theme.spacing(2)};
  }
`;

export const ValuationBackground: React.FC<ValuationBackgroundProps> = ({
  showIcon = true,
  propertyType,
}) => {
  return (
    <StyledBox>
      {showIcon && <IconHouse />}
      <StyledText>
        Die Bewertung für {`${propertyType === 'Wohnung' ? 'Ihre' : 'Ihr'} ${propertyType}`} wurde
        erstellt.
      </StyledText>
      <StyledTextWrapper>
        € <BlurredText>550 000</BlurredText> - € <BlurredText>750 000</BlurredText>
      </StyledTextWrapper>
    </StyledBox>
  );
};
